module.exports = __webpack_public_path__ + "img/Infografis_EN_10.bb9711c3.jpg";